import styled from 'styled-components';
import { gray60, screenXsMax, screenSmMin } from '@spotify-internal/encore-foundation';
import { typeStyleBody2, typeStyleBody3 } from "../../styles";
export default styled.span.withConfig({
  displayName: "Copyright",
  componentId: "sc-1ee822w-0"
})(["color:", ";@media (max-width:", "){", ";}@media (min-width:", "){", ";}"], gray60, screenXsMax, typeStyleBody2(), screenSmMin, typeStyleBody3());